import React, {
  ComponentType,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {TableRow, IconButton} from '@mui/material';
import TableCell from '@mui/material/TableCell';
import {useDrag, useDrop} from 'react-dnd';
import {MoreOptions} from '../../Table/assets/MoreOptions';
import {DoneRounded} from '@mui/icons-material';
import {convertFromRaw} from 'draft-js';
import {stateToHTML} from 'draft-js-export-html';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {formatNumber} from '../../../reducer/actions/formatNumber';
import {service} from '../../../schema/service';
import {useStateContext} from "../../../hooks/useStateContext";
import {hasPermissionByPriority} from "../../../core/permissions/hasPermission";
import {ROLE_PRIORITIES} from "../../../core/permissions/permissions";
import {hasPermissionId} from "../../../core/permissions/hasPermissionId";

const ItemTypes = {
  BOX: 'ROW',
};

const ServiceRow = ({
                      row,
                      index,
                      moveRow,
                      clickOnDelete,
                      clickOnEdit,
                      clickOnOpenViewPrices,
                    }) => {
  const ref = useRef(null);

  const {user} = useStateContext();
  const isAdmin = hasPermissionByPriority(user.roles, ROLE_PRIORITIES[1]);
  const isFinance = hasPermissionId(user.roles, 101);

  const [{isDragging}, drag] = useDrag({
    item: {type: ItemTypes.BOX},
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: 'ROW',
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveRow(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  drag(drop(ref));

  const type = row.service_type_id
    ? row.service_type_id === 1 || row.service_type_id === 2
      ? 'unit'
      : 'var'
    : 'unit';

  var htmlIncludes = '';

  if (row?.includes_notes) {
    htmlIncludes = row?.includes_notes;
  }

  return (
    <TableRow
      style={{opacity: isDragging ? 0.5 : 1}}
      sx={{
        '& .MuiTableCell-root': {
          padding: '5px',
        },
      }}
      key={index}
    >
      <TableCell
        sx={{
          minWidth: '150px',
          width: '150px',
        }}
      >{row?.service_provider?.name}</TableCell>
      <TableCell
        sx={{
          minWidth: '200px',
          width: '200px',
          cursor: 'move',
          '&:hover': {
            background: '#f3f3f3',
          },
        }}
        ref={ref}
      >
        {row?.name}
      </TableCell>
      <TableCell
        sx={{
          minWidth: '150px',
          width: '150px',
        }}
      >
        {row?.staff_required ? (
          <DoneRounded color={'success'}/>
        ) : (
          <CloseRoundedIcon color={'disabled'}/>
        )}
      </TableCell>
      <TableCell
        sx={{
          minWidth: '200px',
          width: '200px',
        }}

        dangerouslySetInnerHTML={{
          __html: htmlIncludes,
        }}
      ></TableCell>
      <TableCell
        sx={{
          minWidth: '100px',
          width: '100px',
        }}
       >
        {type === 'unit' ? (
          <>{formatNumber(row?.unit_price ? row.unit_price : 0)}</>
        ) : (
          <>
            {/* <IconButton
                           onClick={() => {
                               //setOpenViewPrices(row);
                           }}
                       >
                           <VisibilityOutlinedIcon
                               color={'primary'}
                           />
                       </IconButton>*/}
          </>
        )}
      </TableCell>
      <TableCell
        sx={{
          minWidth: '50px',
          width: '50px',
        }}
      >{`${row?.vat ? `${row?.vat} %` : ''}`}</TableCell>
      <TableCell
        sx={{
          minWidth: '100px',
          width: '100px',
        }}
       >
        {type === 'unit' ? (
          <>{formatNumber(row?.unit_price_gross ? row.unit_price_gross : 0)}</>
        ) : (
          <>
            <IconButton
              onClick={() => {
                clickOnOpenViewPrices();
              }}
            >
              <VisibilityOutlinedIcon color={'primary'}/>
            </IconButton>
          </>
        )}
      </TableCell>
      <TableCell
        sx={{
          textAlign: 'left',
          minWidth: '100px',
          width: '100px',
        }}
      >
        {row?.currency?.name}
      </TableCell>
      <TableCell
        sx={{
          textAlign: 'left',
          minWidth: '100px',
          width: '100px',
        }}
      >
        {row?.service_type && <>{row?.service_type?.name}</>}
      </TableCell>
      <TableCell
        sx={{
          minWidth: '50px',
          width: '50px',
        }}
      >
        <MoreOptions
          disabledEdit={(!(isAdmin || isFinance))}
          disabledDelete={!isAdmin}
          clickOnEdit={() => {
            clickOnEdit({
              schema: service,
              row: row,
              tab: 'services',
            });
          }}
          clickOnDelete={() => {
            clickOnDelete();
          }}
        />
      </TableCell>
    </TableRow>
  );
};
export default ServiceRow;
